import theme from '@/assets/theme';

export function getThemeAccentColor(): string {
  return theme.themeType !== 1 ? theme.primary : '#2248D2';
}
